import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { paymentTermRepository } from '../data-access/repositories/PaymentTermRepository'

const base = ['vendor', 'payment-term']

export const paymentTermQueryConfig = {
  all: () => ({
    queryKey: buildQueryKey(base),
  }),
  list: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => paymentTermRepository.list(params),
  }),
}
